import { ChevronRight } from '../../icons/ChevronRight';
import clsx from 'clsx';
import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppStateContext, ActivePane } from '../AppStateProvider/AppStateProvider';
import EquitasLogo from '../EquitasLogo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: `calc(100% - ${theme.navHeight}px)`,
      zIndex: 100,
      background: 'inherit',
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    subheader: {
      display: 'flex',
      justifyContent: 'center',
    },
    breadcrumb: {
      '& p': {
        fontWeight: 600,
        color: '#AEB2C1',
        paddingRight: '2em',
      },
      '&:last-child svg': {
        display: 'none',
      },
      [theme.breakpoints.only('md')]: {
        '& p': {
          width: '80%',
          textAlign: 'center',
        },
      },
    },
    active: {
      '& p': {
        color: theme.typography.body1.color,
      },
    },
    progressBar: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      top: 'calc(100% - 2px)',
      background: '#CACDD8',
    },
    progressBarForeground: {
      background: theme.palette.primary.main,
      width: '0',
      height: '100%',
      transition: 'width 1s ease',
    },
    mobileLogo: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        color: '#4176FF',
        display: 'flex',
        flexDirection: 'column',
        fontSize: '1.5rem',
        fontWeight: 600,
        justifyContent: 'center',
        margin: '0.5em 0.5em 0.5em 0.5em',
      },
    },
    desktopLogo: {
      alignItems: 'stretch',
      color: '#4176FF',
      display: 'flex',
      fontSize: '1.5rem',
      fontWeight: 600,
      justifyContent: 'center',
      margin: '1rem auto 0.5rem',
    },
    gridContainer: {
      justifyContent: 'space-between',
      height: '100%',
      flexWrap: 'wrap',
      [theme.breakpoints.only('md')]: {
        flexWrap: 'nowrap',
      },
    },
    testText: {
      color: '#4176FF',
      fontSize: '1.5rem',
      fontWeight: 600,
      marginRight: '0.75rem',
      textAlign: 'center',
    },
    mobileTestText: {
      color: '#4176FF',
      fontSize: '1.25rem',
      fontWeight: 600,
      marginBottom: '0.4rem',
      textAlign: 'center',
    },
  })
);

function HeaderItem({ label, pane }: { label: string; pane: ActivePane }) {
  const classes = useStyles();
  const { state } = useAppStateContext();

  return (
    <div className={clsx(classes.breadcrumb, { [classes.active]: state.activePane >= pane })}>
      <Grid container alignItems="center">
        <Typography variant="body1">{label}</Typography>
        <ChevronRight />
      </Grid>
    </div>
  );
}

export default function Header() {
  const classes = useStyles();
  const { state } = useAppStateContext();

  const numberOfPanes = Object.keys(ActivePane).length / 2;

  return (
    <>
      <div className={classes.header}>
        <div className={classes.desktopLogo}>
          <div className={classes.testText}>Test your device for</div>
          <EquitasLogo />
        </div>
        <div className={classes.subheader}>
          <Container>
            <Grid container alignItems="center" className={classes.gridContainer}>
              <HeaderItem pane={ActivePane.DeviceCheck} label="Device & Software Setup" />
              <HeaderItem pane={ActivePane.Connectivity} label="Connectivity" />
              <HeaderItem pane={ActivePane.Quality} label="Quality & Performance" />
              <HeaderItem pane={ActivePane.Results} label="Get Results" />
            </Grid>
          </Container>

          <div className={classes.progressBar}>
            <div
              className={classes.progressBarForeground}
              style={{ width: `${(state.activePane / (numberOfPanes - 1)) * 100}%` }}
            />
          </div>
        </div>
      </div>

      <div className={classes.mobileLogo}>
        <div className={classes.mobileTestText}>Test your device for</div>
        <EquitasLogo />
      </div>
      <script dangerouslySetInnerHTML={{ __html: `{window.intercomSettings = {app_id: "o7v9ckl5"}}` }} />
      <script
        defer
        dangerouslySetInnerHTML={{
          __html: `(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/o7v9ckl5';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})()`,
        }}
      />
    </>
  );
}
